import React from 'react';

import 'bootstrap/dist/css/bootstrap.css';
import { BrowserRouter as Router, Route, Routes,useLocation } from 'react-router-dom'
import UserSubscribe from './pages/profile/UserSubscribe';
import Home from './pages/home-page/home';
import Login from './pages/LogIn/Signup/login';
import Signup from './pages/LogIn/Signup/Signup';
import Unverified from './pages/LogIn/Signup/Unverified';
import VerifyEmail from './pages/LogIn/Signup/VerifyEmail';
import ForgotPassword from './pages/LogIn/Signup/ForgotPassword';
import About from './pages/About-page/about'
import ProfileNavbar from './components/ProfileNavbar';
import Faq from './pages/Faq-Page/faq';
import Explore from './pages/Explore/Explore';
import Profile from './pages/profile/profile';
import Accommodations from './pages/Accomodation/Accommodations';
import Booking from './pages/Bookings/Booking';
import UserBooking from './pages/profile/Booking/UserBooking';
import UserAcc from './pages/profile/Accommodation/UserAcc';
import AvailableFlight from './pages/profile/Booking/Flights/AvailableFlight';
import HotelSearch from './pages/profile/Booking/Hotels/HotelSearch';
import FlightItinerary from './pages/profile/Booking/Flights/FlightItinerary';
import HotelItinerary from './pages/profile/Booking/Hotels/HotelItinerary';
import firebase from 'firebase/compat/app'
import 'firebase/compat/auth';
import { useEffect } from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContextProvider } from './AppContext';
import Footer from './components/Footer';
import CarRentals from './pages/profile/CarRentals/carRentals';
import AvailableCars from './pages/profile/CarRentals/AvailableCars';
import CarItinerary from './pages/profile/CarRentals/CarItinerary';
import CarPaymentModal from './pages/profile/CarRentals/CarPayment';
import Contact from './pages/Contact-page/contact';
import Subscribe from './pages/home-page/subscribe';


const firebaseConfig = {
    apiKey: "AIzaSyBKWdYhj6i6NcBAiXmhAktyI_bAMwAJuOo",
    authDomain: "tripz-travel-bot.firebaseapp.com",
    projectId: "tripz-travel-bot",
    storageBucket: "tripz-travel-bot.appspot.com",
    messagingSenderId: "720844828187",
    appId: "1:720844828187:web:00adcaa6e56ca989d0d2be",
    measurementId: "G-5BCYRZXXNW"
  };
  
  firebase.initializeApp(firebaseConfig)










function App() {
  const [user, setUser] = useState(null);
  const [userData, setUserData] = useState(null);
 
  
  useEffect(() => {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        setUser(user);
      } else {
        setUser(null);
      }
    });
  }, []);

  
  
    const handleLogout = () => {
      firebase
        .auth()
        .signOut()
        .then(() => {
          // Successful logout
          setUser(null);
          
        })
        .catch((error) => {
          // Handle logout errors
          console.error('Logout error:', error);
        });
      
    };
   
  return (
   
    <Router>
       <ProfileNavbar handleLogout={handleLogout} userData={userData} setUserData={setUserData}/>
      <Routes>
        <Route exact path='/' element={<Home/>}/>
        
        <Route path='/login' element={<Login setUserData={setUserData}/>}/>
        <Route path='/signup' element={<Signup setUserData={setUserData}/>}/>
        
        <Route path="/verify-email" element={<VerifyEmail/>}/>
        <Route path="/unverified" element={<Unverified/>}/>
        <Route path="/forgot-password" element={<ForgotPassword/>}/>
        <Route path="/booking" element={<Booking/>}/>
        <Route path="/accommodation" element={<Accommodations/>}/>
        <Route path="/explore" element={<Explore/>}/>
        <Route path="/user-booking" element={<UserBooking/>}/>
        <Route path="/user-accommodation" element={<UserAcc/>}/>
        <Route path="/available-flight" element={<AvailableFlight/>}/>
        <Route path="/hotel-search" element={<HotelSearch/>}/>
        <Route path="/hotel-itinerary/:hotelsId" element={<HotelItinerary/>}/>
        <Route path="/flight-itinerary/:flightId" element={<FlightItinerary/>}/>
        <Route exact path="/profile" element={<Profile userData={userData} setUserData={setUserData} handleLogout={handleLogout}/>}/>

      
        <Route path='/about' element={<About/>}/>
        <Route path='/faq' element={<Faq/>}/>
        <Route path='/usersubscribe' element={<UserSubscribe/>}/>
        <Route path='/carRentals' element={<CarRentals/>}/>
        <Route path='/available-cars' element={<AvailableCars/>}/>
        <Route path='/car-payment' element={<CarPaymentModal/>}/>
        <Route path="/car-itinerary/:carsId" element={<CarItinerary/>}/>
        <Route path='/contact' element={<Contact/>} />
        <Route path='/subscribe' element={<Subscribe/>} />
      </Routes>

      <Footer/>
    </Router>
    
  );
}

export default App;
